import { PilotJobOrderChange as ServerPilotJobOrderChange } from 'server/models/PilotJobOrderChange';

import { VesselIdentifier } from 'data/models/PortCall';

export { PilotJobOrderChangeData, PilotJobOrderChangeOptions } from 'server/models/PilotJobOrderChange';

export class PilotJobOrderChange extends ServerPilotJobOrderChange {
    DisplayVesselIdentifier() {
        return VesselIdentifier(() => this.Vessel(), () => this.Agent(), this.Length);
    }
}


// WEBPACK FOOTER //
// ./data/models/PilotJobOrderChange.ts